﻿
import Vue from "vue";
import Component from "vue-class-component";
import common from "../../../common";
import HotEditableFormManager_ from "./HotEditableFormManager";
import utilities_ from "../../utilities";

const utilities = require("../../utilities") as typeof utilities_;
// const HotEditableFormManager = require("./HotEditableFormManager") as HotEditableFormManager_;

declare function __getHotEditableButtonComponentTemplate(): string;

@Component({
    props: {
        initId: String,
        initName: String,
        initClass: String,
        initText: String,
        initTabIndex: Number,
        initDisabled: String,
        initIsHidden: Boolean,
        initManualIcon: Boolean,
        initManualIconHidden: Boolean,
        initManualIconAtRight: Boolean,
        initCustomIconClass: String,
        /** Type de bouton */
        initButtonType: String,
        initButtonOptions: String,
        initLinkUrl: String,
        initLinkTarget: String,
        initTitle: String,
        /** Permet definir une valeur d'action (ActionValue) */
        initActionValue: String,
        /** Permet de forcer le type d'action (ActionType) */
        initActionType: String
    }
})
class HotEditableButtonComponent extends Vue {

    initId?: string;
    initName?: string;
    initClass?: string;
    initText?: string;
    initTabIndex?: number;
    initDisabled?: string;
    initIsHidden?: boolean;//valeur par default
    initManualIcon?: boolean;
    initManualIconHidden?: boolean;
    initManualIconAtRight?: boolean;
    initCustomIconClass?: string;
    initButtonType?: string;
    initButtonOptions?: string;
    initLinkUrl?: string;
    initLinkTarget?: string;
    initTitle?: string;
    initActionValue?: string;
    initActionType?: string;

    rootId?: string;
    idElement?: string;
    elementName?: string;
    cssClass?: string;
    text?: string;
    tabIndex?: number;
    disabled?: boolean;
    isHidden?: boolean;
    manualIcon?: boolean;
    manualIconHidden?: boolean;
    manualIconAtRight?: boolean;
    customIconClass?: string;
    highlighted?: boolean;
    buttonType?: common.HotEditableButtonTypes;
    buttonOptions?: common.HotEditableButtonOptions[];
    linkUrl?: string;
    linkTarget?: string;
    title?: string;
    /** Permet definir une valeur d'action (ActionValue) */
    actionValue?: string;
    /** Permet de forcer le type d'action (ActionType) */
    actionType?: string;

    _formManager?: HotEditableFormManager_ | null;//NOTE?: Doit undefined initialement car il est definie dans le "beforeCreate"
    _linkTargets = {
        blank: "_blank"
    };

    static optionsDelimiter = '|';
    static tagName = "hoteditablebutton";
    static prepareMarkup(element: HTMLElement) {

        if (!element)
            throw "[" + this.tagName + "::prepareMarkup] L'element est NULL";

        element.removeAttribute("hot-editable");
        element.setAttribute("hot-editable-cloak", "");

        const newOuterHtml = element.outerHTML.replace('<button ', '<' + this.tagName + ' ')
            .replace(' id=', ' init-id=')
            .replace(' name=', ' init-name=')
            .replace(' class=', ' init-class=')
            .replace(' button-options=', ' init-button-options=')
            .replace(' button-type=', ' init-button-type=')
            .replace(' text=', ' init-text=')
            .replace(' disabled=', ' init-disabled=')
            .replace(' is-hidden=', ' v-bind:init-is-hidden=')
            .replace(' manual-icon=', ' v-bind:init-manual-icon=')
            .replace(' manual-icon-hidden=', ' v-bind:init-manual-icon-hidden=')
            .replace(' manual-icon-at-right=', ' v-bind:init-manual-icon-at-right=')
            .replace(' custom-icon-class=', ' init-custom-icon-class=')
            .replace(' tabindex=', ' v-bind:init-tab-index=')
            .replace(' link-url=', ' init-link-url=')
            .replace(' link-target=', ' init-link-target=')
            .replace(' title=', ' init-title=')
            .replace(' value=', ' init-action-value=')
            .replace(' type=', ' init-action-type=');

        element.outerHTML = newOuterHtml;
    }
    /** Attribut pour le Css formate ainsi : hef-button-options="|option1|option2|optionN|" */
    getButtonOptions(buttonOptions: common.HotEditableButtonOptions[]) {
        var r = '';
        const d = HotEditableButtonComponent.optionsDelimiter;
        const w = (s: string) => r += d + s + d;
        buttonOptions.forEach(x => {
            if (!x || x !== common.HotEditableButtonOptions.none)
                w(x);
        });
        if (!r.length)
            w(common.HotEditableButtonOptions.none);
        return r;
    }
    data() {

        const toOptionsArray = (s?: string) => {
            const o = ((s || '').split(HotEditableButtonComponent.optionsDelimiter) || []) as string[];
            const r = [] as common.HotEditableButtonOptions[];
            o.forEach(x => {
                if (x) {
                    const a = (common.HotEditableButtonOptions as any)[x];
                    if (!a)
                        throw "L'option '" + x + "' n'est pas valide.";
                    r.push(a);
                }
            });
            return r;
        };
        const defaultCssClass = "mod-button";
        const buttonType: common.HotEditableButtonTypes = (this.initButtonType ? (common.HotEditableButtonTypes as any)[this.initButtonType] : null) ?? function () { throw "[UPA::HotEditationButtonComponent] L'attribut 'button-type' (init-button-type) est requis et doit etre valide (enum::HotEditableButtonType)." }();
        const manualIcon = this.initManualIcon === true;
        var manualIconHidden: boolean;
        var manualIconAtRight: boolean;

        if (manualIcon) {
            manualIconHidden = this.initManualIconHidden === true;
            manualIconAtRight = this.initManualIconAtRight === true;
        } else {
            manualIconHidden = false;
            manualIconAtRight = buttonType !== common.HotEditableButtonTypes.back;
        }

        const guid = utilities.createGuid('N');
        const id = this.initId || "Field_" + guid;

        const o = {
            rootId: "HotEditableField_" + guid,
            idElement: id,
            elementName: this.initName || id,
            cssClass: this.initClass || defaultCssClass,
            buttonOptions: toOptionsArray(this.initButtonOptions),
            buttonType: buttonType,
            text: this.initText || null,
            tabIndex: this.initTabIndex,
            disabled: this.initDisabled === 'disabled',
            isHidden: this.initIsHidden === true,
            manualIcon: manualIcon === true,
            manualIconHidden: manualIconHidden === true,
            manualIconAtRight: manualIconAtRight === true,
            customIconClass: this.initCustomIconClass || '',
            linkUrl: this.initLinkUrl || null,
            linkTarget: this.initLinkTarget || null,
            title: this.initTitle || null,
            actionValue: this.initActionValue || null,
            actionType: this.initActionType || null,
            highlighted: false
        };
        return o;
    }

    created() {

    }

    beforeCreate() {
        this._formManager = (this.$parent as any).formManager.registerButton(this);
        this.$options.template = __getHotEditableButtonComponentTemplate();
    }

    mounted() {
        (this.$el as Element).removeAttribute("hot-editable-cloak");
    }

    show() {
        this.hide(false);
    }

    hide(value?: boolean) {
        value = value !== false;//default is TRUE
        this.isHidden = value;
    }

    enable() {
        return this.isDisabled(false);
    }

    isDisabled(value?: boolean) {
        value = value !== false;
        this.disabled = value;
        return this;
    }

    onEnterClick(event?: KeyboardEvent) {
        //this.preventDefault(event);
        this.click(event);
    }

    onEscapeClick(event?: KeyboardEvent) {
        //this.preventDefault(event);
        this.blur();
    }

    onTabClick(event?: KeyboardEvent) {
        if (event?.shiftKey) {
            this.onShiftTabClick(event);
            return;
        }

        this.focusNextComponent();
        this.preventDefault(event);
    }

    onShiftTabClick(event?: KeyboardEvent) {

        this.focusNextComponent(true);
        this.preventDefault(event);
    }

    private focusNextComponent(getPrevious?: boolean) {
        getPrevious = getPrevious === true;
        this.blur();
        if (getPrevious)
            this._formManager?.focusPreviousComponentFromButton(this)
        else
            this._formManager?.focusNextComponentFromButton(this)
    }

    /** bypassStopPropagation : default=TRUE */
    private preventDefault(e?: Event, bypassStopPropagation?: boolean) {
        if (!e)
            return;

        e.preventDefault();
        if (bypassStopPropagation !== true)
            e.stopPropagation();
    }

    click(event?: any) {
        if (event)
            this.preventDefault(event, true);

        if (this.isHidden)
            return;

        if (this.isLink()) {
            utilities.redirect(this.linkUrl, this.isLinkBlankMode());
            return;
        }

        this._formManager?.buttonClick(this, {
            isCtlClick: utilities.isCtlKeyPressed(event)
        } as common.IButtonClickContext);
    }

    blur() {
        this.getButtonElement().blur();
    }

    focus() {
        this.getButtonElement().focus();
    }

    private getButtonElement() {
        const e = this.$refs["buttonInst"] as HTMLElement;
        return e;
    }

    isLink() {
        return !!this.linkUrl;
    }

    isLinkBlankMode() {
        return this.linkTarget === this._linkTargets.blank;
    }
}

export = HotEditableButtonComponent;